export const isUrl = (value: string): boolean => {
  const urlRegex =
    /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}([\/a-zA-Z0-9-._~:?#@!$&'()*+,;=%]*)?$/;
  return urlRegex.test(value);
};

/**
 * This function is used to compare the pathname of two urls.
 */
export const equalUrlPathNames = (url1: string = '', url2: string = ''): boolean => {
  const url1Pathname = isUrl(url1) ? new URL(url1).pathname : url1;
  const url2Pathname = isUrl(url2) ? new URL(url2).pathname : url2;

  return url1Pathname === url2Pathname;
};
